export const SET_REPORTED_WISHLIST = "setReportedWishlist";
export const SET_WISHLIST = "setWishlist";
// export const EDIT_MUTATION_WISHLIST = "editMutationWishlist";
export const DISABLE_REPORTED_WISHLIST_MUTATION = "disableMutationWishlistMutation";
export const STORE_SHARE_EVENTID_MUTATION = "shareEventIdForShareMutation";
export const SET_JOINED_WISHLIST_ID_MUTATION = "setJoinedWishlistIdMutation";
export const SET_EVENT_PRICING_MUTATION = "setEventPricingMutation";